<template>
    <div class="modal fade" id="add-schedule-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content" style="min-height: 500px;">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>Lägg till tid <span id="add-schedule-modal-date"></span></span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                </div>

                <div class="modal-body pb-5">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>{{ transEdit('start') }}</label>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>{{ transEdit('end') }}</label>
                            </div>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div v-for="(schedule, index) in schedules" :key="index" class="row">
                        <div class="col-md-5">
                            <div class="form-group">
                                <div class="input-group input-group date" id="schedule_start">
                                    <input type="time" class="form-control form-control" v-model="schedule.start" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <div class="input-group input-group date" id="schedule_start">
                                    <input type="time" class="form-control form-control" v-model="schedule.end"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 d-flex align-items-center justify-content-between">
                            <i v-if="index != 0" class="fa fa-minus" @click="remove(index)"></i>
                            <i v-if="index == (schedules.length -1)" class="fa fa-plus" @click="add()"></i>
                        </div>
                    </div>
                    <div>
                        <span v-if="loading"><i class="fa fa-spin fa-fw fa-refresh"></i> {{
                                transEdit('loading')
                            }}...</span>
                    </div>
                    <div class="text-danger">
                        <span v-if="error">{{ transEdit('admin.schedules.create.conflicts-exist') }}</span>
                    </div>
                    <span class="hidden" id="add-schedule-modal-therapist-hidden"></span>
                    <span class="hidden" id="add-schedule-modal-batch-hidden"></span>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary"
                            v-on:click="addSchedule"><i class="fa fa-plus"></i> {{
                            transEdit('therapist-add-schedule')
                        }}
                    </button>
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i> {{ transEdit('cancel') }}
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import VueMultiselect from "vue-multiselect/src/Multiselect";

export default {
    name: "therapist-dash-modal-add-schedule",
    components: {VueMultiselect},

    data() {
        return {
            companies: [],
            selectedCompany: null,
            locations: [],
            selectedLocation: null,
            treatments: [],
            selectedTreatment: null,
            loading: false,
            error: false,
            schedules: [
                {
                    start: '12:00',
                    end: '12:30',
                }
            ],
        }
    },
    computed: {
        filterLocations() {
            let simplifiedLocations = [];
            if (this.locations) {
                this.locations.forEach((location) => {
                    let tempAddressString = location.city.name + ' ' + location.address;
                    simplifiedLocations.push({
                        id: location.id,
                        address: tempAddressString,
                    });
                });
            }

            return simplifiedLocations;
        },
    },
    methods: {
        add() {
            this.schedules.push({
                'start': '',
                'end': '',
            });
        },

        remove(index) {
            this.schedules.splice(index, 1);
        },

        addSchedule: function () {
            this.error = false;
            let thisModal = $("#add-schedule-modal");
            let scheduleDate = $("#add-schedule-modal-date").text();
            let batchId = $("#add-schedule-modal-batch-hidden").text();

            //remove schedule where start and end is empty
            this.schedules = this.schedules.filter((schedule) => {
                return schedule.start !== '' && schedule.end !== '';
            });

            axios.post(this.$portalUrl('adminschedule/schedule'), {
                batch_id: batchId,
                date: scheduleDate,
                schedules: this.schedules,
            }).then((res) => {
                this.loading = false;
                this.$emit('refresh');
                thisModal.modal('toggle');
            }).catch((res) => {
                this.error = true;
            });
        }
    }
}
</script>

<style scoped>

</style>
